/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {SalesExtendedVoModel} from '../sales-extended-vo.model';
import {OppRevenueVoModel} from './opp-revenue-vo.model';
import {JSONable} from '@irian-ro/abstract-resource';

export class OpportunityMetaDataModel extends JSONable {

  salesExtendedVo: SalesExtendedVoModel | undefined = undefined;

  oppRevenueVo: OppRevenueVoModel | undefined = undefined;

  pipelineStageOptions: Array<string> | undefined = undefined;

  opportunityTypeOptions: Array<string> | undefined = undefined;
}
